export enum AUTHENTICATOR_COMPONENT {
  ON_BOARDING = 'ON_BOARDING',
}
